import { render, staticRenderFns } from "./templateBodypart.vue?vue&type=template&id=6efeff64&scoped=true"
import script from "./templateBodypart.vue?vue&type=script&lang=js"
export * from "./templateBodypart.vue?vue&type=script&lang=js"
import style0 from "./templateBodypart.vue?vue&type=style&index=0&id=6efeff64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efeff64",
  null
  
)

export default component.exports